import { PdpState } from '@ff-os/pdp-shared-redux/store';
import { scenePlugins } from '@ff-os/pdp-shared-registry/index';

export const setStartupProjectFromScene = (state?: PdpState): PdpState | undefined => {

    if (!state) {
        return state;
    }

    const plugin = scenePlugins.require(state.scene.pluginId);
    return {
        ...state,
        project: plugin.project.initialize(state.scene.project)
    };
};